import React from "react";

// A number with each figure in its own slot, one 0 wide less the count's
// tracking (--track), so it keeps its width as it climbs: Poppins has no
// tabular figures, and its 1 is half as wide as its 0. See .fig.
export default function Figures({ children }) {
  return [...String(children)].map((figure, at) => (
    <span key={at} className="fig">
      {figure}
    </span>
  ));
}
